import React, { ReactNode } from 'react';

import { Link } from 'react-router-dom';

export type hasChineseIdType = {
    chinese_id: string;
};
export type hasRecipeIdType = {
    recipes_id: string;
    english_name: string;
};

export type hasBotanicalIdType = {
    botanical_id: string;
};

export type hasUniprotIdType = {
    uniprot_entry: string;
};
export type hasIngredientIdType = {
    ingredients_id: string;
};
export type hasDiseaseIdType = {
    id: string;
};

export const chineseDrugLink = <T extends hasChineseIdType>(text: string, record: T): ReactNode => (
    <Link to={`/plant/herb/${record.chinese_id}`} rel="noopener noreferrer">
        {text}
    </Link>
);

export const recipeLink = <T extends hasRecipeIdType>(text: string, record: T): ReactNode => (
    <Link to={`/recipe/detail/${record.english_name}/${record.recipes_id}`} rel="noopener noreferrer">
        {text}
    </Link>
);

export const plantDetailLink = <T extends hasBotanicalIdType>(text: string, record: T): ReactNode => (
    <Link to={`/plant/detail/${record.botanical_id}`} rel="noopener noreferrer">
        {text}
    </Link>
);

export const uniprotDetailLink = <T extends hasUniprotIdType>(text: string, record: T): ReactNode => (
    <Link to={`/target/${record.uniprot_entry}`} rel="noopener noreferrer">
        {text}
    </Link>
);

export const keggPathExternalLink = (text: string): ReactNode => (
    <a href={`https://www.genome.jp/dbget-bin/www_bget?pathway+${text}`} target="_blank" rel="noopener noreferrer">
        {text}
    </a>
);

export const keggTargetExternalLink = (text: string): ReactNode => (
    <a href={`https://www.genome.jp/dbget-bin/www_bget?+${text}`} target="_blank" rel="noopener noreferrer">
        {text}
    </a>
);

export const chemblTargetExternalLink = (text: string): ReactNode => (
    <a href={`https://www.ebi.ac.uk/chembl/target_report_card/${text}`} target="_blank" rel="noopener noreferrer">
        {text}
    </a>
);

export const uniprotTargetExternalLink = (text: string): ReactNode => (
    <a href={`https://www.uniprot.org/uniprot/${text}`} target="_blank" rel="noopener noreferrer">
        {text}
    </a>
);

export const ingredientLink = <T extends hasIngredientIdType>(text: string, record: T): ReactNode => (
    <Link to={`/ingredient/detail/${record.ingredients_id}`} rel="noopener noreferrer">
        {text}
    </Link>
);
export const diseaseLink = <T extends hasDiseaseIdType>(text: string, record: T): ReactNode => (
    <Link to={`/disease/detail/${record.id}`} rel="noopener noreferrer">
        {text}
    </Link>
);
